import View from '../../../Core/View.js';

const DELAY = 8000;

export default class HeaderSlideshow extends View {

	initialize() {
		this.$allSlides = this.$el.find('.header__slide');

		this.prevIndex = 2;
		this.currentIndex = 0;
		this.nextIndex = 1;
		this.lastIndex = this.$allSlides.length - 1;
		this.carouselRunning = true;

		if (this.$allSlides.length <= 1) {
			return;
		}

		this.interval = setInterval(this.nextSlide.bind(this), DELAY);
		document.addEventListener('visibilitychange', this.handleVisibilityChange.bind(this));
		// this.$el.find('.header__cursor--left').on('click', this.handlePreviousClick.bind(this));
		// this.$el.find('.header__cursor--right').on('click', this.handleNextClick.bind(this));

		this.updateState(0);

		setTimeout(function() {
			this.$allSlides.removeClass('header__slide--loading');
		}.bind(this), 1000);
	}

	destroy() {
	}

	nextSlide() {
		let newIndex = this.currentIndex + 1;
		if (this.currentIndex === this.lastIndex) {
			newIndex = 0;
		}

		this.updateState(newIndex);
	}

	previousSlide() {
		let newIndex = this.currentIndex - 1;
		if (this.currentIndex === 0) {
			newIndex = this.lastIndex;
		}

		this.updateState(newIndex);
	}

	updateState(index, direction) {
		if (! this.carouselRunning) {
			return;
		}

		this.prevIndex = index === 0 ? this.lastIndex : index - 1;
		this.currentIndex = index;
		this.nextIndex = index === this.lastIndex ? 0 : index + 1;

		this.updateCarouselPosition(direction);
	}

	updateCarouselPosition(direction) {
		this.$el.find('.header__slide--initial').removeClass('header__slide--initial');
		this.$el.find('.header__slide--previous').removeClass('header__slide--previous');
		this.$el.find('.header__slide--current').removeClass('header__slide--current');
		this.$el.find('.header__slide--next').removeClass('header__slide--next');

		this.$allSlides.eq(this.prevIndex).addClass('header__slide--previous');
		this.$allSlides.eq(this.currentIndex).addClass('header__slide--current');
		this.$allSlides.eq(this.nextIndex).addClass('header__slide--next');
		this.$allSlides.eq(this.currentIndex).css('z-index', 10)

		if (direction === 'right') {
			this.$allSlides.eq(this.prevIndex).css('z-index', 0);
			this.$allSlides.eq(this.nextIndex).css('z-index', 1);
		} else {
			this.$allSlides.eq(this.prevIndex).css('z-index', 1);
			this.$allSlides.eq(this.nextIndex).css('z-index', 0);
		}
	}

	handleVisibilityChange() {
		this.carouselRunning = ! document.hidden;
	}

	handlePreviousClick(event) {
		event.preventDefault();
		this.previousSlide();
	}

	handleNextClick(event) {
		event.preventDefault();
		this.nextSlide();
	}
}


// WEBPACK FOOTER //
// ./js/Views/Templates/HeaderSlideshow/HeaderSlideshow.js